"use strict";
import { ChainSelector } from "components/NavBar/ChainSelector";
import { NewUserCTAButton } from "components/NavBar/DownloadApp/NewUserCTAButton";
import { PreferenceMenu } from "components/NavBar/PreferencesMenu";
import { useTabsVisible } from "components/NavBar/ScreenSizes";
import TestnetModeTooltip from "components/NavBar/TestnetMode/TestnetModeTooltip";
import Web3Status from "components/Web3Status";
import Row from "components/deprecated/Row";
import { useAccount } from "hooks/useAccount";
import { PageType, useIsPage } from "hooks/useIsPage";
import deprecatedStyled, { css } from "lib/styled-components";
import { Flex, Nav as TamaguiNav, styled, useMedia } from "ui/src";
import { INTERFACE_NAV_HEIGHT, breakpoints, zIndexes } from "ui/src/theme";
import { useEnabledChains } from "uniswap/src/features/chains/hooks/useEnabledChains";
import { FeatureFlags } from "uniswap/src/features/gating/flags";
import { useFeatureFlag } from "uniswap/src/features/gating/hooks";
const UnpositionedFlex = styled(Flex, {
  position: "unset"
});
const Nav = styled(TamaguiNav, {
  position: "unset",
  px: "$padding12",
  width: "100%",
  height: INTERFACE_NAV_HEIGHT,
  zIndex: zIndexes.sticky,
  justifyContent: "center"
});
const NavItems = css`
  gap: 12px;
  @media screen and (max-width: ${breakpoints.md}px) {
    gap: 4px;
  }
`;
const Left = deprecatedStyled(Row)`
  display: flex;
  align-items: center;
  wrap: nowrap;
  ${NavItems}
`;
const Right = deprecatedStyled(Row)`
  justify-content: flex-end;
  ${NavItems}
`;
function useShouldHideChainSelector() {
  const isLandingPage = useIsPage(PageType.LANDING);
  const isSendPage = useIsPage(PageType.SEND);
  const isSwapPage = useIsPage(PageType.SWAP);
  const isLimitPage = useIsPage(PageType.LIMIT);
  const isExplorePage = useIsPage(PageType.EXPLORE);
  const isPositionsPage = useIsPage(PageType.POSITIONS);
  const isMigrateV3Page = useIsPage(PageType.MIGRATE_V3);
  const isBuyPage = useIsPage(PageType.BUY);
  const isSellPage = useIsPage(PageType.SELL);
  const multichainHiddenPages = isLandingPage || isSendPage || isSwapPage || isLimitPage || isExplorePage || isPositionsPage || isMigrateV3Page || isBuyPage || isSellPage;
  return multichainHiddenPages;
}
export default function Navbar() {
  const isLandingPage = useIsPage(PageType.LANDING);
  const media = useMedia();
  const isSmallScreen = media.md;
  const areTabsVisible = useTabsVisible();
  const collapseSearchBar = media.xl;
  const account = useAccount();
  const hideChainSelector = useShouldHideChainSelector();
  const { isTestnetModeEnabled } = useEnabledChains();
  const isEmbeddedWalletEnabled = useFeatureFlag(FeatureFlags.EmbeddedWallet);
  return <Nav><div style={{ paddingInline: "30px" }}><UnpositionedFlex row centered width="100%"><Left><h2 style={{ color: "#00F5E0" }}>AggTrade - Swap</h2>{
    /* {areTabsVisible && <Tabs />} */
  }</Left>{
    /* {!collapseSearchBar && <SearchBar />} */
  }<Right>{
    /* {collapseSearchBar && <SearchBar />} */
  }{!isEmbeddedWalletEnabled && isLandingPage && !isSmallScreen && <NewUserCTAButton />}{!account.isConnected && !account.isConnecting && <PreferenceMenu />}{!hideChainSelector && <ChainSelector />}{isTestnetModeEnabled && <TestnetModeTooltip />}{isEmbeddedWalletEnabled && !account.address && <NewUserCTAButton />}<Web3Status /></Right></UnpositionedFlex></div></Nav>;
}
